import { render, staticRenderFns } from "./QuickstartTab.vue?vue&type=template&id=60023439&scoped=true&"
import script from "./QuickstartTab.vue?vue&type=script&lang=js&"
export * from "./QuickstartTab.vue?vue&type=script&lang=js&"
import style0 from "./quickstart-tab.scss?vue&type=style&index=0&id=60023439&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60023439",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60023439')) {
      api.createRecord('60023439', component.options)
    } else {
      api.reload('60023439', component.options)
    }
    module.hot.accept("./QuickstartTab.vue?vue&type=template&id=60023439&scoped=true&", function () {
      api.rerender('60023439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/QuickstartTab/QuickstartTab.vue"
export default component.exports